class ApiService {
  static token () {
    this.csrfParam = this.csrfParam || document.querySelector('meta[name=csrf-param]').getAttribute('content');
    this.csrfToken = this.csrfToken || document.querySelector('meta[name=csrf-token]').getAttribute('content');
    return { [this.csrfParam]: this.csrfToken };
  }
}

export default ApiService;
